import { render, staticRenderFns } from "./RobberyEventTypeQuestion.vue?vue&type=template&id=5189eb25&scoped=true"
import script from "./RobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyEventTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189eb25",
  null
  
)

export default component.exports